<template>
  <div class="main">
    <library-topbar @burger-clicked="menuClicked = !menuClicked" :menu-is-open="menuClicked" :is-on-tablet="responsive !== 'desktop'" :connection="connection" />
    <burger
      :is-opened="menuClicked"
      @menu-toggle="menuClicked = $event.value"
      :is-on-tablet="responsive !== 'desktop'"></burger>
    <div class="c-access-denied__wrapper page-wrap">
      <div v-if="book" class="c-access-denied__box">
        <h1 class="c-access-denied__title">{{ $t('ACCESS_DENIED_HEADING') }}</h1>
        <div class="c-access-denied__image-wrapper">
          <img crossorigin="anonymous" :alt="$t('BOOK_COVER')" v-lazy="`https://editor.dpm.fagbokforlaget.no/streams/${book._id}/cover`" class="c-access-denied__image">
          <div class="c-access-denied__image--bookside"></div>
          <div class="c-access-denied__image--bookline"></div>
          <div class="c-access-denied__image--bookbottom"></div>
        </div>
        <h2 class="c-access-denied__book-title">
          {{ book.title | truncate(100) }}
        </h2>
        <a class="c-access-denied__btn" :href="`https://www.fagbokforlaget.no/d-bok/I${book.isbn}`" target="_blank" >{{ $t('ACCESS_DENIED_BUTTON_TEXT') }}</a>
        <span class="c-access-denied__contact-text" v-html="$t('ACCESS_DENIED_CONTACT_TEXT')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { setDocumentTitle } from '@/utils/utils'
import bookService from '@/services/book'

import LibraryTopBar from '@/components/LibraryTopBar'
import BurgerMenu from '@/components/BurgerMenu'

export default {
  name: 'library',

  components: {
    'library-topbar': LibraryTopBar,
    'burger': BurgerMenu
  },

  data () {
    return {
      menuClicked: false,
      book: null
    }
  },

  watch: {
    ['$i18n.locale']() {
      setDocumentTitle(this.$t('ACCESS_DENIED'))
    }
  },

  computed: {
    ...mapState('book', {
      books: state => state.books,
      savedBooks: state => state.savedBooks
    }),

    ...mapState('userSettings', {
      connection: state => state.connection,
      filterBy: state => state.libraryFilter.value,
      load: state => state.libraryLoaded,
      libraryScrollPos: state => state.libraryScrollPos,
      filterOffline: state => state.libraryFilterOffline,
      responsive: state => state.responsive
    })
  },

  async beforeMount() {
    setDocumentTitle(this.$t('ACCESS_DENIED'))

    if (!this.$route.query.bookId) return
    this.book = await bookService.getBook(this.$store.state.user.accessToken, this.$route.query.bookId)
  },

  methods: {
    //
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';
@import '@/assets/scss/_breakpoints.scss';

html {
  background: linear-gradient(to bottom, $white 0%, $dark-blue 500%);
  min-height: 100vh;
}

.c-access-denied__box {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.c-access-denied__title {
  font-size: 1.25rem;
  color: $dark-blue;
}

.c-access-denied__btn {
  @include btn();
  background-color: $orange;
  color: $white;
  border-color: $orange;
  font-size: 1.125rem;
  font-weight: 500;
  letter-spacing: -0.5px;
  text-align: center;
  padding: 0.65rem 3rem;
  margin: 1.25rem auto 0.875rem;

  &:hover {
    background-color: $orange-hover;
    border-color: $orange-hover;
  }

  @include edge {
    font-weight: bold;
  }
  @include a11yOutline();
}

.c-access-denied__image-wrapper {
  position: relative;
  display: inline-block;
  height: 180px;
  width: auto;
  text-align: center;
  margin-top: 2rem;
  @include bookShadow();
}

.c-access-denied__image {
  display: block;
  margin: 0 auto;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
}

.c-access-denied__image--bookside {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 3px;
  background: #333;
  opacity: 0.6;
  border-top-left-radius: 2px;
}

.c-access-denied__image--bookline {
  position: absolute;
  top: 0;
  left: 10px;
  height: 100%;
  width: 1px;
  background: #333;
  opacity: 0.4;
}

.c-access-denied--bookbottom {
  position: absolute;
  bottom: 0;
  left: 2px;
  right: 0;
  width: calc(100% - 2px);
  height: 2px;
  background: #333;
  opacity: 0.6;
  border-top-left-radius: 2px;
}

.c-access-denied__wrapper {
  margin: 0 auto;
  padding: 50px 20px 50px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: calc(100vh - 100px);
}

.c-access-denied__book-title {
  font-size: 0.875em;
  font-weight: 700;
  letter-spacing: -0.1px;
  color: $dark-blue;
  line-height: 1.3;
  min-height: 2em;
  display: inline-block;
  max-width: 14em;
  margin-bottom: 1em;
  text-align: center;
}

.c-access-denied__contact-text {
  font-size: 0.875rem;
  color: $blue;

  a {
    color: $blue;
    text-decoration: underline;
  }
}
</style>
